import * as React from 'react'
import { Form } from 'react-bootstrap'
import Annotation from 'components/Annotation'
import iconPasswordEye from 'images/icon_password_eye.svg'
import iconPasswordEyeSlash from 'images/icon_password_eye_slash.svg'

interface Props {
  name: string
  value?: string
  label?: string
  ariaLabel?: string
  type: string
  placeholder?: string
  bold?: boolean
  className?: string
  style?: React.CSSProperties
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  setValue?: (value: string) => void
  notes?: string[]
  errors?: string[]
}

const Component: React.FC<Props> = ({ name, value, label, ariaLabel, type, placeholder, bold, className, style, onChange, setValue, notes, errors }) => {
  const originalOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (setValue) {
      setValue(event.target.value)
    }
    if (onChange) {
      onChange(event)
    }
  }
  const noteList = (notes ?? []).filter(Boolean)
  const errorList = (errors ?? []).filter(Boolean)
  const [_type, setType] = React.useState(type)
  const passwordEyeOnClick = () => {
    setType(_type === 'password' ? 'text' : 'password')
  }
  return (
    <div id={`input_item_id_${name}`} className={className} style={{ ...{ textAlign: 'left' }, ...style }}>
      {label && <Form.Label className={`${bold ? 'fw-bold ' : ''}font-15`}>{label}</Form.Label>}
      <div className={`input-container${errorList.length > 0 ? ' border-danger border-2' : ''}`}>
        <Form.Control
          data-testid={name}
          className="border-0 p-3"
          name={name}
          value={value}
          type={_type}
          placeholder={placeholder}
          onChange={originalOnChange}
          aria-label={ariaLabel}
        />
        <span onClick={passwordEyeOnClick} role="button">
          <img src={_type === 'password' ? iconPasswordEyeSlash : iconPasswordEye} alt="Password Icon" className="input-password-icon" loading="lazy" />
        </span>
      </div>
      {noteList.length > 0 && <Annotation notes={noteList} />}
      {errorList.length > 0 && <Annotation notes={errorList} warn />}
    </div>
  )
}

export default Component
